import { SettingsConstant } from "./../constants/settings.constants";
import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
  HttpHeaders,
  HttpParams
} from "@angular/common/http";

import { Observable, throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { GenericUtils } from "./../utilities/generic-utils";
import { environment } from "./../../../environments/environment";
import { LocalStorageService } from "./local-storage.service";
import { ApiUrlConstant } from "../constants/api-url.constant";
import { LoginService } from "../../core/services/login.service"
import { CommonService } from "./common.service"

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
  constructor(
    private utils: GenericUtils,
    private localStorage: LocalStorageService,
    private apiUrl: ApiUrlConstant,
    private loginService: LoginService,
    private commonService: CommonService
  ) { }
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    const new_token: string = this.commonService.getCookie(`${environment.accessToken}`)

    const telescope_token: string = this.localStorage.getItem(
      SettingsConstant.LOCALSTORAGE_KEYS.TELESCOPE_TOKEN
    );
    const ums_token: string = this.localStorage.getItem(
      SettingsConstant.LOCALSTORAGE_KEYS.UMS_APP_TOKEN
    );

    // let token = request.params.get('ums_token') ? ums_token : telescope_token;
    let token = new_token || '';

    const contentType = "application/json";
    
    if (token) {
      token = token.split(' ')[0] === 'Bearer' ? token : `Bearer ${token}`;
    }

    let __headers = {};

    if (request.url.includes(`${environment.UMS_HOST}`)) {
      __headers = {
        Authorization: token ? token : ''
      };
    }
    else {
      const user = this.localStorage.getItem(`${SettingsConstant.LOCALSTORAGE_KEYS.USER_DETAILS}`);
      const uuid = user && user.uuid ? user.uuid : (user && user.sub ? user.sub : '');
      __headers = {
        Authorization: token,
        "USER-UUID": uuid,
        "CLIENT-UUID": this.localStorage.getItem(`${SettingsConstant.LOCALSTORAGE_KEYS.SELECTED_CLIENT}`)
        //"X-ID-TOKEN": this.localStorage.getItem(SettingsConstant.LOCALSTORAGE_KEYS.ID_TOKEN)
        //"USER-UUID": "anmol",
      };
    }
    request = request.clone({
      headers: new HttpHeaders(__headers),
      params: request.params.delete('ums_token'),
    });

    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
        }
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        let data = {};
        if (error && error.status === 401) {
          // auto logout if 401 response returned from api
          // 666
          this.loginService.logOut();
          return throwError(error);
        }
        data = {
          reason:
            error && error.error && error.error.reason
              ? error.error.reason
              : "",
          status: error.status
        };
        return throwError(error);
      })
    );
  }
}
